import toast from "react-hot-toast";

import { useProductStore } from "@/_zustand/store";
import { useMachine } from "@/_zustand/machine";
import { formatMoney } from "@/lib";
import {
  resolverPrecioProducto,
  resolverBadgesDescuento,
  resolverSubtotalProducto,
} from "@/lib/precioProducto";
import "./CartProductCard.css";
import { BlueTag } from "../../store/components/BlueTag";
import { RedTag } from "../../store/components/RedTag";
import { OfferTag } from "../../store/components/OfferTag";

export const ProductsComponent = ({ product, stockBolsa }) => {
  const { addToCart, calculateTotals, removeFromCart, setDiscount } =
    useProductStore();
  const { machineSelected, logoMachine, nameEmpresa, addressMachine } =
    useMachine();

  const handleQuantityChange = (actionName) => {
    let amount = 1;
    if (actionName === "plus") {
      const limiteStock = Math.min(
        product.stock ?? Infinity,
        product.stock_maximo ?? Infinity,
      );
      if (product.producto_cant >= limiteStock) {
        toast.error(
          `No puedes agregar más de ${limiteStock} unidades de este producto.`,
        );
        return;
      }
      amount = product.producto_cant + 1;
    } else if (actionName === "minus" && product.producto_cant !== 1) {
      amount = product.producto_cant - 1;
    }

    let dataToAdd = {
      ...product,
      producto_cant: amount,
      maquina_id: machineSelected,
      logo_machine: logoMachine,
      name_empresa: nameEmpresa,
      address_machine: addressMachine,
    };
    addToCart(dataToAdd, machineSelected);
    calculateTotals(machineSelected);
    //validStock();
  };

  const handleRemoveProduct = (id) => {
    removeFromCart(id, machineSelected);
    calculateTotals(machineSelected);
    setDiscount(0, 0, null);
  };

  const CartProductCard = ({ product }) => {
    const isOutOfStock = stockBolsa.includes(product.producto_id);
    const { precioFinal, precioOriginal, tieneDescuento } =
      resolverPrecioProducto(product);
    const {
      subtotal,
      subtotalOriginal,
      tieneDescuento: subtotalTieneDescuento,
    } = resolverSubtotalProducto(product, product.producto_cant);
    const badges = resolverBadgesDescuento(product);

    return (
      <div className="cart-product-card" key={product.producto_id}>
        <img
          src={product.producto_foto}
          alt={product.producto_nombre}
          className="cart-product-image"
        />
        <div>
          <p className="cart-product-name">{product.producto_nombre}</p>
          {isOutOfStock && (
            <span className="cart-out-stock">Fuera de stock</span>
          )}
        </div>
        <div className="cart-product-info">
          <div className="cart-product-pricing">
            <span className="cart-price">
              {formatMoney(precioFinal)} CLP
            </span>
            {tieneDescuento && (
              <span className="cart-original-price">
                {formatMoney(precioOriginal)} CLP
              </span>
            )}
          </div>
        </div>
        <div className="cart-product-actions">
          <div className="cart-tags">
            {badges.map((badge, i) =>
              badge.tipo === "porcentaje" ||
              badge.tipo === "porcentaje-oferta" ? (
                <RedTag key={i} percentage={badge.percentage} />
              ) : badge.tipo === "2x1" ? (
                <BlueTag key={i} />
              ) : (
                <OfferTag key={i} />
              ),
            )}
          </div>
        </div>

        <div className="cart-product-actions" style={{ textAlign: "right" }}>
          <div className="cart-quantity">
            {product.producto_cant == 1 && (
              <button
                className="cart-remove-btn"
                onClick={() => handleRemoveProduct(product.producto_id)}
              >
                <i className="fas fa-trash"></i>
              </button>
            )}
            {product.producto_cant > 1 && (
              <button onClick={() => handleQuantityChange("minus")}>–</button>
            )}
            <span>{product.producto_cant}</span>
            <button onClick={() => handleQuantityChange("plus")}>+</button>
          </div>
        </div>
        {/* Subtotal de la línea — resuelto por el mismo módulo que usa
            calculateTotals, para que lo que se muestra acá sea exactamente lo
            que esa línea aporta al total cobrado. Antes este bloque tenía su
            propio ladder (con una rama por descuento_tipo_id==3 y otra por
            2x1) que ya divergía del cobro real. */}
        <div className="cart-product-info">
          <span className="cart-price">{formatMoney(subtotal)} CLP</span>
          {subtotalTieneDescuento && (
            <div>
              <span className="cart-original-price">
                {formatMoney(subtotalOriginal)} CLP
              </span>
            </div>
          )}
        </div>
      </div>
    );
  };

  return <CartProductCard product={product} />;
};
